// extracted by mini-css-extract-plugin
export default {"address":"style_address__GZM4W","address1":"style_address1__sFpvi","address2":"style_address2__PfMEV","city":"style_city__I9eaQ","zip":"style_zip__E9w0s"};